import { createSelector } from '@ngrx/store';
import { getAuthState } from './feature.selector';
import { AuthState } from '../auth.state';

export const selectUserState = createSelector(getAuthState, (state: AuthState) => state.user);
